// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { number, string } from 'prop-types'
import useGeneratingMessage from './hooks/useGeneratingMessage'

const GeneratingMessage = ({ exportJobId, initialJobStatus, uid }) => {
  const jobStatus = useGeneratingMessage(exportJobId, initialJobStatus, uid)

  return (
    <p className={'padding-bottom-1'}>
      {jobStatus}
    </p>
  )
}

GeneratingMessage.propTypes = {
  exportJobId: number.isRequired,
  initialJobStatus: string.isRequired,
  uid: string.isRequired,
}

export default GeneratingMessage
